
import { Options, Vue } from "vue-class-component";
import FormLogin from "@/views/FormLogin.vue";

@Options({
  components: { FormLogin },
})
export default class AuthLayout extends Vue {}
